import type { ApiResponse, PagedResponseDto } from "@/types/common";
import type { CmsPageCreateDto, CmsPageDto, CmsPageUpdateDto } from "@/types/cms.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const cmsService = {
  getBySlug(slug: string): Promise<CmsPageDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<CmsPageDto>>(`/Pages/slug/${slug}`));
  },

  getAll(page = 1, pageSize = 50, publishedOnly = true): Promise<PagedResponseDto<CmsPageDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<CmsPageDto>>>("/Pages", {
        params: { page, pageSize, publishedOnly },
      }),
    );
  },

  create(dto: CmsPageCreateDto): Promise<CmsPageDto> {
    return unwrapApiResponse(apiClient.post<ApiResponse<CmsPageDto>>("/Pages", dto));
  },

  update(id: number, dto: CmsPageUpdateDto): Promise<CmsPageDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<CmsPageDto>>(`/Pages/${id}`, dto));
  },

  delete(id: number): Promise<boolean> {
    return unwrapApiResponse(apiClient.delete<ApiResponse<boolean>>(`/Pages/${id}`));
  },
};
